import { TIENDA } from "../data/config";
import Reveal from "./ui/Reveal";

// Sin API oficial de Instagram (no se permiten dependencias externas), se
// muestra una galería que enlaza al perfil real. Cada imagen abre la cuenta.
const PUBLICACIONES = [
  {
    src: "https://images.pexels.com/photos/5566235/pexels-photo-5566235.jpeg?auto=compress&cs=tinysrgb&w=500",
    alt: "Frasco de mantequilla de maní Agora junto a maníes",
  },
  {
    src: "https://images.pexels.com/photos/6659901/pexels-photo-6659901.jpeg?auto=compress&cs=tinysrgb&w=500",
    alt: "Tostada con mantequilla de maní natural",
  },
  {
    src: "https://images.pexels.com/photos/7253551/pexels-photo-7253551.jpeg?auto=compress&cs=tinysrgb&w=500",
    alt: "Maníes tostados artesanalmente",
  },
  {
    src: "https://images.pexels.com/photos/13682251/pexels-photo-13682251.jpeg?auto=compress&cs=tinysrgb&w=500",
    alt: "Maníes naturales sobre madera",
  },
  {
    src: "https://images.pexels.com/photos/19559056/pexels-photo-19559056.jpeg?auto=compress&cs=tinysrgb&w=500",
    alt: "Desayuno saludable con maní",
  },
  {
    src: "https://images.pexels.com/photos/36476223/pexels-photo-36476223.jpeg?auto=compress&cs=tinysrgb&w=500",
    alt: "Textura cremosa de la mantequilla de maní Agora",
  },
];

const InstagramFeed = () => {
  return (
    <section className="bg-surface-low py-20 md:py-section">
      <div className="mx-auto max-w-container px-5 md:px-16">
        <Reveal className="mx-auto max-w-3xl text-center">
          <span className="text-xs font-semibold uppercase tracking-label text-secondary">
            Síguenos en Instagram
          </span>
          <h2 className="mt-3 font-literata text-2xl font-bold text-charcoal sm:text-3xl md:text-4xl">
            @{TIENDA.instagram}
          </h2>
          <p className="mt-4 text-base text-ink-variant sm:text-lg">
            Recetas, novedades y el día a día de Agora. Únete a nuestra comunidad
            maní-fanática.
          </p>
        </Reveal>

        <ul className="mt-10 grid grid-cols-2 gap-3 sm:mt-12 sm:grid-cols-3 sm:gap-4">
          {PUBLICACIONES.map((post, indice) => (
            <Reveal as="li" key={indice} delay={indice * 60}>
              <a
                href={TIENDA.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block overflow-hidden rounded-lg"
                aria-label={`Ver publicación en Instagram: ${post.alt}`}
              >
                <img
                  src={post.src}
                  alt={post.alt}
                  className="aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <span className="absolute inset-0 flex items-center justify-center bg-charcoal/0 text-3xl text-white opacity-0 transition-all duration-300 group-hover:bg-charcoal/40 group-hover:opacity-100" aria-hidden="true">
                  ❤
                </span>
              </a>
            </Reveal>
          ))}
        </ul>

        <div className="mt-12 text-center">
          <a
            href={TIENDA.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 rounded-xl border-2 border-peanut px-8 py-4 text-base font-semibold text-charcoal transition-colors hover:bg-peanut/20"
          >
            <svg viewBox="0 0 24 24" width="1.2em" height="1.2em" fill="currentColor" aria-hidden="true">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
            </svg>
            Ver perfil completo
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
